const upperFirst = (str) => {
    str = str.toLowerCase()
    return str.replace(/\b\w|\s\w/g, fw => {
        return fw.toUpperCase()
    })
}
const modulesFiles = require.context('./modules', true, /.js$/)
const ModuleApi = {}
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const value = modulesFiles(modulePath)
    Object.assign(ModuleApi, value.default)
}, {})

const pluginsFiles = require.context('./plugins', true, /.js$/)
const PluginsApi = pluginsFiles.keys().reduce((modules, modulePath) => {
    const moduleName = upperFirst(modulePath.replace(/^.\/(.*)\.js/, '$1'))
    const value = pluginsFiles(modulePath)
    modules[moduleName] = value.default
    return modules
}, {})

export default {
    ...ModuleApi,
    Plugins: {
        ...PluginsApi
    }
}
